import React from 'react';
import { useMicrosite } from '../../../../contexts/franchise/microsite-context';

const FranchiseLicenses = (): JSX.Element => {
    const microsite = useMicrosite();

    const {
        biohazardContractorLicense,
        cslbContractorLicense,
        commercialContractorLicense,
        electricalContractorLicense,
        generalContractorLicense,
        moldRemediationContractorLicense,
        plumbingContractorLicense,
        residentialContractorLicense,
    } = microsite?.franchise?.licenses || {};

    const licenseTexts = {
        'Biohazard Cleanup': biohazardContractorLicense,
        'CSLB (California)': cslbContractorLicense,
        Commercial: commercialContractorLicense,
        'Electrical License': electricalContractorLicense,
        'General Contractor License': generalContractorLicense,
        'Mold Remediation': moldRemediationContractorLicense,
        Plumbing: plumbingContractorLicense,
        Residential: residentialContractorLicense,
    };

    return (
        <div>
            {Object.entries(licenseTexts).map(([key, val]) => {
                if (val && typeof val !== 'boolean') {
                    return (
                        <div
                            key={key}
                            css={{
                                marginBottom: '8px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: '#374151',
                            }}
                        >
                            <strong>
                                {key}
                                :
                            </strong>
                            {' '}
                            {val}
                        </div>
                    );
                }
                if (val && typeof val === 'boolean') {
                    return (
                        <div
                            key={key}
                            css={{
                                marginBottom: '8px',
                                whiteSpace: 'nowrap',
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: '#374151',
                            }}
                        >
                            <strong>{key}</strong>
                        </div>
                    );
                }
                return null;
            })}
        </div>
    );
};

export default FranchiseLicenses;
